import React from 'react';
import { motion } from 'framer-motion';
import { demoSwitchNote, separateWorkspacesCopy, workspacePanels } from '../../data/noetivra';
import { fadeUp } from '../../utils/motion';

/** Government demo's two workspaces and how they connect (shown on /government). */
export function NoetivraWorkspaces() {
  return <section id="workspaces" aria-labelledby="workspaces-title" className="scroll-mt-20 bg-surface-bg border-y border-line py-20 lg:py-24" data-id="element-1502" data-mp="1p0c0a8bkrvve">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1503" data-mp="2cmqsz8nd5l7d">
        <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 mb-12" data-id="element-1504" data-mp="2gp5czw2rqr08">
          <div className="lg:col-span-5" data-id="element-1505" data-mp="22pvw0u6qnsv7">
            <p className="text-sm font-medium text-teal mb-3" data-id="element-1506" data-mp="22t1kc77jmqpv">Government demo · NCDS</p>
            <h2 id="workspaces-title" className="font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight leading-tight" data-id="element-1507" data-mp="27ruzs56e4rso">
              Separate workspaces, connected workflows.
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pt-8 space-y-3" data-id="element-1508" data-mp="23d049mp5p7oz">
            <p className="text-lg text-ink-dark leading-relaxed" data-id="element-1509" data-mp="1zawsewyks136">{separateWorkspacesCopy}</p>
            <p className="text-ink-muted leading-relaxed" data-id="element-1510" data-mp="2daehldfs9gd2">{demoSwitchNote}</p>
          </div>
        </motion.div>
        <motion.ul {...fadeUp} className="grid grid-cols-1 md:grid-cols-3 gap-px bg-line border border-line rounded-lg overflow-hidden" data-id="element-1511" data-mp="28as91hawgoal">
          {workspacePanels.map((panel, index) => {
          const last = index === workspacePanels.length - 1;
          return <li key={panel.title} className={`p-8 ${last ? 'bg-navy-deep text-white' : 'bg-white'}`} data-id="element-1512" data-mp="2w1fkgck0xw1w" data-mpi={index}>
                <h3 className={`font-heading font-bold text-xl mb-3 ${last ? 'text-white' : 'text-ink-dark'}`} data-id="element-1513" data-mp="2r1je46nutsj6">{panel.title}</h3>
                <p className={`leading-relaxed ${last ? 'text-white/80' : 'text-ink-muted'}`} data-id="element-1514" data-mp="35zlgidj5g7yu">{panel.body}</p>
              </li>;
        })}
        </motion.ul>
      </div>
    </section>;
}